import * as React from "react"
import * as R from "ramda"
import Table from "@kiwicom/orbit-components/lib/Table"
import TableHead from "@kiwicom/orbit-components/lib/Table/TableHead"
import TableBody from "@kiwicom/orbit-components/lib/Table/TableBody"
import TableRow from "@kiwicom/orbit-components/lib/Table/TableRow"
import TableCell from "@kiwicom/orbit-components/lib/Table/TableCell"
import RadioButtonsOption from "@kiwicom/frontend-common/components/RadioButtons/RadioButtonsOption"

import type { Test } from "./records/Tests"

type Props = {
  test: Test
  handleChange: () => void
}

const RenderTable = ({ test, handleChange }: Props) => {
  // @ts-expect-error: Typescript update resulted in an error.
  const ratioSum = R.compose(R.sum, R.pluck("ratio"), R.values)(test.variants)

  return (
    <Table>
      <TableHead>
        <TableRow>
          {/* @ts-expect-error: Flow to TS migration. */}
          <TableCell />
          <TableCell>value</TableCell>
          <TableCell>percentage</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {R.compose(
          R.map((variant) => (
            // @ts-expect-error: Flow to TS migration.
            <TableRow key={variant.val}>
              <TableCell>
                <RadioButtonsOption
                  // @ts-expect-error: Flow to TS migration.
                  mode={{ value: variant.value, cssClass: "normal-case" }}
                  handleChange={handleChange}
                  active={test.winningVariant || test.defaultVariant}
                />
              </TableCell>
              {/* @ts-expect-error: Flow to TS migration. */}
              <TableCell>{variant.value}</TableCell>
              {/* @ts-expect-error: Flow to TS migration. */}
              <TableCell>{Math.round((10000 * variant.ratio) / ratioSum) / 100} %</TableCell>
            </TableRow>
          )),
          // @ts-expect-error: Flow to TS migration.
          R.sort(R.comparator((a, b) => a.value < b.value)),
          R.values,
        )(test.variants)}
      </TableBody>
    </Table>
  )
}

export default RenderTable
